export default __webpack_public_path__ + "static/media/video-detail.8cb5622d.mp4";